export default __webpack_public_path__ + "static/media/teladoc.76cd57b4.svg";